import actionTypes from "./actionTypes";

export const fetchSummaryAction = data => {
  return {
    type: actionTypes.FETCH_SUMMARY,
    payload: data
  };
};

export const fetchSummaryFailedAction = err => {
  return {
    type: actionTypes.FETCH_SUMMARY_FAILED,
    payload: err
  };
};

export const fetchSummarySuccessAction = data => {
  return {
    type: actionTypes.FETCH_SUMMARY_SUCCESS,
    payload: data
  };
};

export const generateWorkItemPDF = workItemId => {
  return {
    type: actionTypes.WORK_ITEM_PDF_REPORT,
    payload: workItemId
  };
};
